import React from 'react';
import EditPostContent from './content';
import EditPostProvider from 'contexts/edit-post.context/provider';

const EditPostLayout = () => {
  return (
    <EditPostProvider>
      <EditPostContent />
    </EditPostProvider>
  );
};

export default EditPostLayout;
